import { apiSlice } from './apiSlice';
const DRAFT_URL = '/api/draft';

export const draftApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllDrafts: builder.query({
      query: () => DRAFT_URL,
      providesTags: ['Drafts'],
    }),
    getDraftById: builder.query({
      query: (draftId) => `${DRAFT_URL}/${draftId}`,
      providesTags: (result, error, draftId) => [{ type: 'Drafts', id: draftId }],
    }),
    getDraftByLeague: builder.query({
      query: (leagueId) => `${DRAFT_URL}/league/${leagueId}`,
      providesTags: (result, error, leagueId) => [
        { type: 'Drafts', id: result?._id },
        { type: 'LeagueDraft', id: leagueId }
      ],
    }),
    createDraft: builder.mutation({
      query: (draftData) => ({
        url: DRAFT_URL,
        method: 'POST',
        body: draftData,
      }),
      invalidatesTags: ['Drafts'],
    }),
    updateDraftStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `${DRAFT_URL}/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Drafts', id }],
    }),
    makeDraftPick: builder.mutation({
      query: ({ draftId, athleteId, teamId }) => ({
        url: `${DRAFT_URL}/${draftId}/pick`,
        method: 'POST',
        body: { athleteId, teamId },
      }),
      invalidatesTags: (result, error, { draftId }) => [{ type: 'Drafts', id: draftId }],
    }),
    refreshAvailableAthletes: builder.mutation({
      query: (id) => ({
        url: `${DRAFT_URL}/${id}/refresh`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Drafts', id }],
    }),
    updateDraftDetails: builder.mutation({
      query: ({ id, startTime, seasonStartDate }) => ({
        url: `${DRAFT_URL}/${id}`,
        method: 'PUT',
        body: { startTime, seasonStartDate },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Drafts', id }],
    }),
  }),
});

export const {
  useGetAllDraftsQuery,
  useGetDraftByIdQuery,
  useGetDraftByLeagueQuery,
  useCreateDraftMutation,
  useUpdateDraftStatusMutation,
  useMakeDraftPickMutation,
  useRefreshAvailableAthletesMutation,
  useUpdateDraftDetailsMutation
} = draftApiSlice;
